export const FETCH_LIST_APPRENANTS = "FETCH_LIST_APPRENANTS";

export const FETCH_LIST_MODULES = "FETCH_LIST_MODULES";
